export default [
    {
        path: '/receivables/overview',

        name: 'Company Account Receivables / Overview',

        component: () => import('@/views/pages/receivables/overview'),
    },
    {
        path: '/receivables/accounts',

        name: 'Company Account Receivables / Accounts',

        component: () => import('@/views/pages/receivables/accounts'),
    },
];